@if (formLoading) {
  <div class="kbm-search-loading">
    <p-progressSpinner></p-progressSpinner>
  </div>
}
<p-toast [style]="{marginTop: '80px'}">
</p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>
<div class="container-fluid glb-popup payment-popup">
  <h2> {{formTitle}}</h2>

  <button mat-icon-button [mat-dialog-close]="true" style="float:right;top:-50px;background-color: transparent;">
    <i class="pi pi-times" aria-hidden="true"></i>
  </button>
  <hr>

    <div class="mb-2 d-flex justify-content-end">
      <!-- <h3 class="step-inner-title text-capitalize">Payment</h3> -->
      <div class="payment-icons">
        <img src="../../../assets/images/payment-icon/visa.svg">
        <img src="../../../assets/images/payment-icon/mastercard.svg">
        <img src="../../../assets/images/payment-icon/american-express-1.svg">
        <img src="../../../assets/images/payment-icon/discover-4.svg">
      </div>
    </div>
    <div [formGroup]="form2" class="forms w-100 d-block">
      <div formGroupName="paymentSource" class="floating-form">
        <div class="row">
          <div class="col-12">
            <span class="p-float-label w-100">
              <p-dropdown class="w-100" [options]="paymentSources" formControlName="paymentSourceId" (onChange)="selectPaymentSource($event)" optionLabel="name" optionValue="value"
                [filter]="true" filterBy="name"
              placeholder="Source Account"></p-dropdown>
              <label for="paymentSourceId">Source Account</label>
              @for (validation of validationMessages1.paymentSourceId; track validation) {
                <span>
                  @if (form2.get('paymentSource.paymentSourceId').hasError(validation.type) && (form2.get('paymentSource.paymentSourceId').dirty || form2.get('paymentSource.paymentSourceId').touched)) {
                    <small class="p-invalid"
                      >{{validation.message}}
                    </small>
                  }
                </span>
              }
            </span>
          </div>

          <div class="col-6">
            <span class="p-float-label w-100">
              <input formControlName="paymentAmount" id="paymentAmount" type="text" pInputText>
              <label for="paymentAmount">Payment Amount $</label>
            </span>
            @for (validation of validationMessages1.paymentAmount; track validation) {
              <span>
                @if (form2.get('paymentSource.paymentAmount').hasError(validation.type) && (form2.get('paymentSource.paymentAmount').dirty || form2.get('paymentSource.paymentAmount').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </div>

          <!-- Classic Run Payment: standard 5-option Action dropdown. -->
          @if (!deferredCapture) {
            <div class="col-6">
              <span class="p-float-label w-100">
                <p-dropdown class="w-100" [options]="paymentCreditCardRequests" formControlName="paymentCreditCardRequestedTransactionType" optionLabel="name" optionValue="value"
                placeholder="Action"></p-dropdown>
                <label for="paymentCreditCardRequestedTransactionType">Action</label>
                @for (validation of validationMessages1.paymentCreditCardRequestedTransactionType; track validation) {
                  <span>
                    @if (form2.get('paymentSource.paymentCreditCardRequestedTransactionType').hasError(validation.type) && (form2.get('paymentSource.paymentCreditCardRequestedTransactionType').dirty || form2.get('paymentSource.paymentCreditCardRequestedTransactionType').touched)) {
                      <small class="p-invalid"
                        >{{validation.message}}
                      </small>
                    }
                  </span>
                }
              </span>
            </div>
            <div class="col-6"></div>
          }
          <!-- Combined Authorize / Capture mode: radio toggle picks AO or PC.
               When PC is selected, the prior-auth dropdown appears below. -->
          @if (deferredCapture) {
            <div class="col-12 mb-2">
              <div class="d-flex align-items-center gap-3">
                <label class="me-2 fw-bold mb-0">Action:</label>
                <label class="d-flex align-items-center gap-1 mb-0">
                  <input type="radio" formControlName="paymentCreditCardRequestedTransactionType" value="AO" />
                  <span>Authorize Only</span>
                </label>
                <label class="d-flex align-items-center gap-1 mb-0">
                  <input type="radio" formControlName="paymentCreditCardRequestedTransactionType" value="PC" />
                  <span>Authorize Capture</span>
                </label>
              </div>
              @if (form2.get('paymentSource.paymentCreditCardRequestedTransactionType')?.value === 'AO') {
                <small class="text-muted">Auth now; capture will be performed later (manually or by the scheduler).</small>
              }
              @if (form2.get('paymentSource.paymentCreditCardRequestedTransactionType')?.value === 'PC') {
                <small class="text-muted">PA-Charge against the prior auth selected below.</small>
              }
            </div>
            @if (form2.get('paymentSource.paymentCreditCardRequestedTransactionType')?.value === 'PC') {
              <div class="col-12">
                @if (priorAuths && priorAuths.length > 0) {
                  <span class="p-float-label w-100">
                    <p-dropdown class="w-100" [options]="priorAuths" formControlName="priorAuthTxnId"
                      optionLabel="name" optionValue="value" placeholder="Prior Auth"></p-dropdown>
                    <label for="priorAuthTxnId">Prior Auth</label>
                  </span>
                } @else {
                  <small class="p-invalid">No prior authorizations available — switch to Authorize Only above.</small>
                }
              </div>
            }
          }

          <div class="col-6"></div>
          <div class="col-12">
            <span class="p-float-label">
              <input name="cardName" formControlName="cardName" type="text" pInputText>
              <label for="cardName">Name on Card</label>
            </span>
            @for (validation of validationMessages1.cardName; track validation) {
              <div>
                @if (form2.get('paymentSource.cardName').hasError(validation.type) && (form2.get('paymentSource.cardName').dirty || form2.get('paymentSource.cardName').touched)) {
                  <small
                  class="p-error">{{validation.message}}</small>
                }
              </div>
            }
          </div>
          <div class="col-12">
            <span class="p-float-label">
              <input name="cardNumber" formControlName="cardNumber" minlength="15" maxlength="19" type="text" pInputText>
              <label for="cardNumber">Credit or Card Number</label>
            </span>
            @for (validation of validationMessages1.cardNumber; track validation) {
              <div>
                @if (form2.get('paymentSource.cardNumber').hasError(validation.type) && (form2.get('paymentSource.cardNumber').dirty || form2.get('paymentSource.cardNumber').touched)) {
                  <small
                  class="p-error">{{validation.message}}</small>
                }
              </div>
            }
          </div>
          <div class="col-6 arrive-info--dropdown">
            <span class="p-float-label">
              <p-dropdown formControlName="cardExpirationMonth" name="cardExpirationMonth" [autoDisplayFirst]="false" [options]="months" optionLabel="name" optionValue="value">
              </p-dropdown>
              <label for="cardNumber">Exp Month</label>
            </span>
            @for (validation of validationMessages1.cardExpirationMonth; track validation) {
              <div>
                @if (form2.get('paymentSource.cardExpirationMonth').hasError(validation.type) && (form2.get('paymentSource.cardExpirationMonth').dirty || form2.get('paymentSource.cardExpirationMonth').touched)) {
                  <small
                  class="p-error">{{validation.message}}</small>
                }
              </div>
            }
            <!-- <div *ngIf="pastCardExpirationMonth">
            <small class="p-error">Month cannot be in past</small>
          </div> -->
        </div>
        <div class="col-6 arrive-info--dropdown">
          <span class="p-float-label">
            <p-dropdown formControlName="cardExpirationYear" name="cardExpirationYear" [autoDisplayFirst]="false" [options]="years" optionLabel="name" optionValue="value">
            </p-dropdown>
            <label for="cardNumber">Exp Year</label>
          </span>
          @for (validation of validationMessages1.cardExpirationYear; track validation) {
            <div>
              @if (form2.get('paymentSource.cardExpirationYear').hasError(validation.type) && (form2.get('paymentSource.cardExpirationYear').dirty || form2.get('paymentSource.cardExpirationYear').touched)) {
                <small
                class="p-error">{{validation.message}}</small>
              }
            </div>
          }
        </div>
        <div class="col-6">
          <span class="p-float-label">
            <input name="cardSecurityCode" formControlName="cardSecurityCode" minlength="3" maxlength="4" type="text" pInputText>
            <label for="cardSecurityCode">Security code</label>
          </span>
          @for (validation of validationMessages1.cardSecurityCode; track validation) {
            <div>
              @if (form2.get('paymentSource.cardSecurityCode').hasError(validation.type) && (form2.get('paymentSource.cardSecurityCode').dirty || form2.get('paymentSource.cardSecurityCode').touched)) {
                <small
                class="p-error">{{validation.message}}</small>
              }
            </div>
          }
        </div>
        <div class="col-6 mb-lg-0 position-relative">
          <span class="p-float-label">
            <input name="postalCode" formControlName="postalCode" type="text" pInputText>
            <label for="postalCode">Postal code</label>
          </span>
          @for (validation of validationMessages1.postalCode; track validation) {
            <div style="display: block; height: fit-content; position: relative;">
              @if (form2.get('paymentSource.postalCode').hasError(validation.type) && (form2.get('paymentSource.postalCode').dirty || form2.get('paymentSource.postalCode').touched)) {
                <small class="p-error"
                style="left: 10px;">{{validation.message}}</small>
              }
            </div>
          }
        </div>

      </div>

      <div class="mb-2">
        <h3 style="font-size: 20px;" class="mb-3 step-inner-title text-capitalize">Terms</h3>
        <div class="position-relative mb-2">
          <div class="d-flex justify-content-start align-items-center">
            <div class="form-check form-switch pl-0">
              <input mdbCheckbox formControlName="iAgree" (click)="checkedIAgree($event, 'iAgree')" class="form-check-input" type="checkbox" id="flexSwitchCheckDefault2" />
            </div>
            <p class="mb-0 sm-text ms-2">I have read and
              understand the
              <a class="text text-decoration-underline">terms
              & cancellation policy</a>.
            </p>
          </div>
          @for (validation of validationMessages1.iAgree; track validation) {
            <div>
              @if (isGuestAgreeForCreditCard) {
                <small class="pt-1 p-error position-relative bottom-0 start-0" style="font-size: 0.75rem;">{{validation.message}}</small>
              }
            </div>
          }
        </div>
      </div>
    </div>
  </div>

  <div class="row reservation-btn">
    <div class="col-12">
      <div class="d-flex justify-content-end flex-column-reverse flex-lg-row">
        <button class="mb-3 btn btn-orange step-form-btn text-capitalize mb-lg-0 w-100 w-md-auto" (click)="makeAdditionalPayment()" [disabled]="disabledBookReservationButton || chargeSubmitting"
          style="border-color: #299A01 !important; background-color: #299A01 !important; background: #299A01 !important;">
          {{ chargeSubmitting ? 'Processing…' : 'Make Payment' }}
        </button>
      </div>
    </div>
  </div>

</div>

<p-dialog header="PAYMENT" [(visible)]="showPaymentSuccess" [modal]="true" [draggable]="false" [resizable]="true">
  <section class="thankyou_messag">
    <div class="container">
      <div class="d-flex justify-content-center align-items-center flex-column mb-3">
        <i class="pi pi-check-circle me-3" style="font-size:5em;color:green"></i>
        <h3>Payment success, thank you.</h3>

        <p>Please click on ok button for update invoice.</p>
        <div class="cancle-btn">
          <button class="btn btn-cancle btn-orange" (click)="closePaymentDialog()">OK</button>
        </div>
      </div>
    </div>

  </section>
  <!-- <div>
  <div>
    <h5 style="color:grey;">PAYMENT</h5>
    <p><i class="pi pi-check-circle" style="color:green"></i>&nbsp;&nbsp;&nbsp;<b
  style="color:green">Success</b><br><br>Please click on ok button for update invoice.
</p>
</div>

<div class="p-fluid p-grid">
  <div class="p-field p-col-12">
    <div style="margin-top:100px;">
      <button pButton type="button" (click)="closePaymentDialog()" label="OK" class="p-button-outlined"></button>
    </div>
  </div>
</div>
</div> -->
</p-dialog>